export function isOnlyHexadecimal(value) {
  return value && (typeof value === 'string' || value instanceof String) && /^[a-f0-9]+$/.test(value.replaceAll('.', ''));
}
